import { NotificationCategory, NotificationMethod } from "./enums";

export enum NotificationPreferenceValue {
    Notify = "notify",
    Skip = "skip",
}

export interface PersonNotificationPreferencesData {
    person_id: number;
    method: NotificationMethod;
    category: NotificationCategory;
    updated_at: string;
    value: NotificationPreferenceValue;
}

export const defaultNotificationPreference: Record<NotificationCategory, NotificationPreferenceValue> = {
    [NotificationCategory.A1_ACCOUNT_ACTIVATION]: NotificationPreferenceValue.Notify,
    [NotificationCategory.A2_WELCOME_COMPANY]: NotificationPreferenceValue.Notify,
    [NotificationCategory.A3_LAST_MINUTE_APPLICATION_CHANGE]: NotificationPreferenceValue.Skip,
    [NotificationCategory.N2_MISSING_DOCUMENTS]: NotificationPreferenceValue.Notify,
    [NotificationCategory.V1_VODAFONE_TARIFF_NEW_APPLICATION]: NotificationPreferenceValue.Notify,
    [NotificationCategory.V2_VODAFONE_TARIFF_NEW_APPLICATION_PAYMENT_REMINDER]: NotificationPreferenceValue.Notify,
    [NotificationCategory.V3_VODAFONE_APPLICATION_STORNO]: NotificationPreferenceValue.Notify,
    [NotificationCategory.V4_VODAFONE_TARIFF_BILLING_NEW]: NotificationPreferenceValue.Notify,
    [NotificationCategory.V5_VODAFONE_TARIFF_BILLING_REMINDER]: NotificationPreferenceValue.Notify,
    [NotificationCategory.V6_VODAFONE_TRANSFER_DATE]: NotificationPreferenceValue.Notify,
    [NotificationCategory.N3_UNCONFIRMED_EMAIL]: NotificationPreferenceValue.Notify,
    [NotificationCategory.T1_ACCOUNT_ACTIVATION]: NotificationPreferenceValue.Notify,
    [NotificationCategory.T2_WELCOME_TYMBER]: NotificationPreferenceValue.Notify,
    [NotificationCategory.T3_PERSON_DOCUMENT_VALIDATED]: NotificationPreferenceValue.Notify,
    [NotificationCategory.T4_NEW_SIGNED_CONTRACT]: NotificationPreferenceValue.Notify,
    [NotificationCategory.T5_TYMBER_SHIFT_INVITE]: NotificationPreferenceValue.Notify,
    [NotificationCategory.T6_RESET_PASSWORD]: NotificationPreferenceValue.Notify,
    [NotificationCategory.T7_RESET_PASSWORD_DONE]: NotificationPreferenceValue.Notify,
    [NotificationCategory.T8_AUTO_BAN]: NotificationPreferenceValue.Notify,
    [NotificationCategory.T9_COMPANY_BLOCKED_USER]: NotificationPreferenceValue.Notify,
    [NotificationCategory.T10_DEPARTMENT_BLOCKED_USER]: NotificationPreferenceValue.Notify,
    [NotificationCategory.T11_BRANCHOFFICE_BLOCKED_USER]: NotificationPreferenceValue.Notify,
    [NotificationCategory.T15_EXCUSE_CLARIFICATION_NEEDED]: NotificationPreferenceValue.Notify,
    [NotificationCategory.T16_REJECTED_EXCUSE]: NotificationPreferenceValue.Notify,
    [NotificationCategory.T20_LIFE_CHANGE]: NotificationPreferenceValue.Notify,
    [NotificationCategory.T21_OUT_OF_LIVES_BAN]: NotificationPreferenceValue.Notify,
    [NotificationCategory.T23_FREE_SHIFTS_AROUND_TYMBER]: NotificationPreferenceValue.Notify,
    [NotificationCategory.T24_MARKETING]: NotificationPreferenceValue.Notify,
    [NotificationCategory.T27_MULTISPORT_ACTIVATION]: NotificationPreferenceValue.Notify,
    [NotificationCategory.T28_MULTISPORT_PERIOD_EVALUATION_REMINDER]: NotificationPreferenceValue.Notify,
    [NotificationCategory.T29_EMPLOYER_SHIFT_CANCELLATION]: NotificationPreferenceValue.Notify,
    [NotificationCategory.T30_PINK_DECLARATION_SIGNED]: NotificationPreferenceValue.Notify,
    [NotificationCategory.CUSTOM_NOTIFICATION]: NotificationPreferenceValue.Notify,
};
